import './skeleton.scss';

import LoadingSkeleton, {
  type SkeletonProps as LoadingSkeletonProps,
} from 'react-loading-skeleton';

import { cn } from '../../utils/helpers';

export type SkeletonVariant = 'dark';

export type SkeletonProps = LoadingSkeletonProps & {
  variant?: SkeletonVariant;
};

export const Skeleton: React.FC<SkeletonProps> = ({
  variant,
  className,
  ...props
}) => (
  <LoadingSkeleton
    className={cn(className, {
      'react-loading-skeleton--dark': variant === 'dark',
    })}
    {...props}
  />
);
